/**
 * @file index.tsx
 *
 * @fileoverview Renders large organization profile teaser.
 */
import Image from '~/jobiqo/components/Image';
import { OrganizationProfileParagraph } from '~/jobiqo/types/types';
import { OrganizationTeaserLarge as VclOrganizationTeaserLarge } from '~/vcl/organisms/09-organization/02-organization-teaser-large';
import Link from '~/jobiqo/components/Link';
import { getTranslatedLink } from '~/jobiqo/utils/links';
import MapMarker from '~/vcl/icons/MapMarker';
import { OfficeIcon } from '~/vcl/icons/Office';
import { NetworkIcon } from '~/vcl/icons/Network';
import { BriefcaseIcon } from '~/vcl/icons/Briefcase';
import { FormattedMessage } from 'react-intl';
export interface OrganizationTeaserLargeProps
  extends Omit<OrganizationProfileParagraph, 'title' | 'subtitle'> {
  /**
   * The flag to apply the box-shadow: none style.
   *
   * @default false
   */
  boxShadowNone?: boolean;
  /**
   * The row title.
   */
  rowTitle?: string;
  /**
   * The row subtitle.
   */
  rowSubtitle?: string;
}

export function OrganizationTeaserLarge({
  rowTitle,
  rowSubtitle,
  organizationProfile: {
    name,
    url,
    organizationLocation,
    size,
    industry,
    organizationJobsCount,
    logo,
    cover,
  },
  boxShadowNone = false,
}: OrganizationTeaserLargeProps) {
  return (
    <VclOrganizationTeaserLarge
      title={rowTitle}
      subtitle={rowSubtitle}
      Name={<Link href={getTranslatedLink(url?.path)}>{name}</Link>}
      Banner={
        cover?.url && (
          <Image
            src={cover.url}
            alt={cover.alt ?? name}
            title={cover.title ?? name}
            width={null}
            height={null}
          />
        )
      }
      Logo={
        logo?.url && (
          <Image
            src={logo.url}
            alt={logo.alt ?? name}
            title={logo.title ?? name}
            width={128}
            height={128}
          />
        )
      }
      fields={[
        {
          Icon: <MapMarker />,
          Label: organizationLocation?.address ?? '',
        },
        {
          Icon: <OfficeIcon />,
          Label: industry?.label ?? '',
        },
        {
          Icon: <NetworkIcon />,
          Label: size?.label ?? '',
        },
        {
          Icon: <BriefcaseIcon />,
          Label:
            organizationJobsCount && organizationJobsCount > 0 ? (
              <Link
                href={{
                  pathname: '/jobs',
                  query: { job_organization_name: name },
                }}
              >
                <FormattedMessage
                  values={{ count: organizationJobsCount }}
                  id="organization_jobs_count"
                  defaultMessage="{count, plural, one {# open position} other {# open positions}}"
                />
              </Link>
            ) : null,
        },
      ]}
      boxShadowNone={boxShadowNone}
    />
  );
}
export default OrganizationTeaserLarge;
